import { connect } from 'react-redux';
import Text from 'src/components/text/Text';
import localeService from 'src/dataServices/LocaleService';
import { emailAddressValidator, emailRequiredFieldValidator } from './ProfileV2SharedComponents';
import TextInputV2 from './TextInputV2';

export interface IRenderEmailsProps {
  fields: any;
}

export const RenderEmails = (props: IRenderEmailsProps) => {
  const { fields } = props;

  const handleAddField = () => {
    fields.push(undefined);

    setTimeout(() => {
      const newIndex = fields.length - 1;
      const input = document.querySelector(`input[name="${fields.name}[${newIndex}]"]`) as HTMLInputElement;

      input?.focus();
    }, 0);
  };

  return (
    <div>
      {fields && fields.length > 0 && (
        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
            <div id="alternate-email-group-label">
              <Text category="ProfileV2" id="AlternateEmailAddress" />
            </div>
          </div>
        </div>
      )}
      <div
        className="notification-emails"
        id="notificationEmails"
        role="group"
        aria-labelledby="alternate-email-group-label"
      >
        {fields &&
          fields.map((email: string, index: number) => (
            <div key={index}>
              <div className="ms-Grid-row mt-2">
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
                  <TextInputV2
                    id={`${fields.name}[${index}]`}
                    localeCategoryId="ProfileV2"
                    localeLabelId="AlternateEmailAddress"
                    required={true}
                    autoFocus={true}
                    placeholder={
                      (localeService.getText('ProfileV2', 'AlternateEmailPlaceholder') ?? '') + `#${index + 1}`
                    }
                    labelText={`Alternate email address #${index + 1}`}
                    validators={[emailRequiredFieldValidator, emailAddressValidator]}
                  />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
                  <button
                    id={'DeleteButton' + `${index}`}
                    type="button"
                    className="action-trigger glyph-prepend glyph-prepend-delete action-button"
                    onKeyDown={(evt: { key: string }) => {
                      if (evt.key === 'Enter') {
                        fields.remove(index);
                      }
                    }}
                    onClick={() => {
                      fields.remove(index);
                    }}
                  >
                    {localeService.getText('ProfileV2', 'Delete')}
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>
      {fields && (
        <div className="ms-Grid-row">
          {fields.length < 5 && (
            <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
              <button
                id="addMoreButton"
                type="button"
                className="action-trigger glyph-prepend glyph-prepend-circle-plus mt-2 action-button"
                onKeyDown={(evt: { key: string }) => {
                  if (evt.key === 'Enter') {
                    handleAddField();
                  }
                }}
                onClick={handleAddField}
              >
                {localeService.getText('ProfileV2', 'AddAlternateEmail')}
              </button>
            </div>
          )}
        </div>
      )}
      {fields && fields.length > 0 && (
        <div className="alternate-email-policy">
          <p className="action-trigger glyph-prepend glyph-prepend-info action-button">
            <Text category="ProfileV2" id="AlternateEmailPolicy" />
          </p>
        </div>
      )}
    </div>
  );
};

export default connect()(RenderEmails);
